<template>
  <div class="base">
    <inside-header title="我的文章" back-link-name="UserIndex" righ-link-name="UserArticlePost" right-link-label="新建" />
    <div class="article-menu">
      <div class="item">
        <div :class="status === 'all' ? 'active' : ''" @click="filterStatus('all')">
          全部({{ group_status.all }})
        </div>
      </div>
      <div class="item">
        <div :class="status === 1 ? 'active' : ''" @click="filterStatus(1)">
          公开({{ group_status.show }})
        </div>
      </div>
      <div class="item">
        <div :class="status === 2 ? 'active' : ''" @click="filterStatus(2)">
          私密({{ group_status.private }})
        </div>
      </div>
      <div class="item">
        <div :class="status === 3 ? 'active' : ''" @click="filterStatus(3)">
          审核({{ group_status.reviewed }})
        </div>
      </div>
      <div class="item">
        <div :class="status === 4 ? 'active' : ''" @click="filterStatus(4)">
          草稿({{ group_status.draft }})
        </div>
      </div>
    </div>
    <div class="main">
      <div class="list">
        <div v-for="(article, key) in list" :key="key" class="item">
          <div class="title" @click="showDetails(article.id)">
            {{ article.title }}
          </div>
          <div class="time-edit clear">
            <span class="time pull-left">{{
                article.create_time | dayFormat
            }}</span>
            <span class="edit pull-right" @click="editDetails(article.id)">编辑</span>
          </div>
        </div>
      </div>
    </div>
    <van-empty v-if="list.length === 0" description="暂无数据" />
    <div v-if="list.length > 0" class="pagination">
      <van-pagination v-model="paginate.current_page" :total-items="paginate.total" :show-page-size="3" force-ellipses
        @change="pageChange" />
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainFooter, InsideHeader } from '@/components'
import merge from 'webpack-merge'

export default {
  name: 'TutorPay',
  components: {
    MainFooter,
    InsideHeader
  },
  props: {
    page: {
      default: 1
    },
    status: {
      default: 'all'
    }
  },
  data() {
    return {
      loading: true,
      list: [],
      paginate: {
        current_page: 1,
        total: 0
      },
      total: '',
      group_status: {
        all: 0,
        show: 0,
        private: 0,
        reviewed: 0,
        draft: 0
      }
    }
  },
  watch: {
    // url改变，重新加载数据
    $route() {
      this.loadData(this.page, this.status)
    },
    paginate(data) {
      this.page = data.current_page
      this.total = data.total
    }
  },
  created() {
    this.loadData(this.page, this.status)
  },
  methods: {
    loadData(page, status) {
      this.loading = true
      this.$http({
        url: '/index/my_forum/list',
        method: 'get',
        params: {
          page: page,
          status: status === 'all' ? '' : status
        }
      }).then(res => {
        this.loading = false
        if (res.status === 'success') {
          const data = res.data
          this.list = data.list
          this.paginate = data.paginate
          this.group_status = data.group_status
          console.log(data)
        } else {
          this.$notification.error({
            message: '错误',
            description: res.message
          })
        }
      })
    },
    showDetails(articleId) {
      this.$router.push({ name: 'ForumInfo', params: { id: articleId } })
    },
    editDetails(articleId) {
      this.$router.push({ name: 'UserArticlePost', query: { id: articleId } })
    },
    pageChange(e) {
      // 修改参数
      this.$router.push({
        query: merge({}, { page: e })
      })
      this.page = e
      this.loadData(e, this.status)
    },
    filterStatus(target) {
      this.$router.push({ name: 'UserMyArticle', query: { status: target } })
    }
  }
}
</script>
<style lang="stylus" scoped>
.base {
  min-width: 280px;
  max-width: 420px;
  margin: auto;
  background-color: #fff;
}

.article-menu {
  height: 40px;
  background-color: #ffffff;
  padding: 0 5px;
  // box-shadow: 1px 2px 5px 0px rgba(200, 200, 200, 0.24);

  .item {
    width: 20%;
    float: left;
    text-align: center;

    .icon {
      font-size: 18px;
    }

    div {
      font-family: PingFang-SC-Medium;
      font-size: 14px;
      line-height: 16px;
      color: #999999;
      line-height: 40px;
    }

    .active {
      font-family: PingFang-SC-Bold;
      font-size: 18px;
      line-height: 16px;
      color: #333333;
      line-height: 36px;
      font-weight: bold;
    }
  }
}

.main {
  padding: 15px;

  .list {

    .item {
      padding: 15px 0;
      border-bottom: 1px solid #e0e0e0;
       .title {
          font-family: PingFang-SC-Medium;
          font-size: 16px;
          line-height: 24px;
          color: #333333;
          height: 48px;
          overflow hidden
       }

       .time-edit {
         margin-top: 10px;
         .time {
          font-family: PingFang-SC-Bold;
          font-size: 12px;
          line-height: 16px;
          color: #999999;
         }

         .edit {
          font-family: PingFang-SC-Medium;
          font-size: 16px;
          line-height: 16px;
          color: #999999;
         }
       }
    }

  }
}
</style>
